import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import * as moment from 'moment';
import 'moment-duration-format';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isNumeric } from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  public examTimerString: any = "";
  public extraTimeString: any = "";
  public adaptedTimeString: any = "";
  public showExtraTime = false;
  public showAdaptedTime = false;
  public isLoaded = false;
  public canShowQuestions = false;
  public showExamCompleteMsg = false;

  private _loadInterval = null;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    private  domSanitizer: DomSanitizer
  ) {

    // Only show if not eproctoring exam or if loaded through wrapper
    let eproctEnabled = false;
    if(this.dataSvc.currentExamIndex > -1) {
      eproctEnabled = this.dataSvc.currentExam().Session.EnableEProctoring;
    }
    let eproctLoaded = this.dataSvc.getParameterByName("eproctored") == "1";
    this.canShowQuestions = !eproctEnabled || (eproctEnabled && eproctLoaded);

    let scheduleId = this.dataSvc.getParameterByName("scheduleId");
    let candidateId = this.dataSvc.getParameterByName("candidateId");
    let username = this.dataSvc.getParameterByName("username");
    
    if(eproctLoaded && scheduleId !== null && scheduleId !== "" && candidateId !== null && candidateId !== "" && username !== null && username !== ""){
      this._loadInterval = setInterval( () => {
        if(!this.dataSvc.syncingConfig) {
          this.dataSvc.initDataDownload(username, scheduleId, candidateId, false).then(() => {
            var examIndex = localStorage.getItem("syncItemExamIndex");
    
            if (!isNumeric(examIndex)) {
              localStorage.setItem("syncItemExamIndex", "0");
            }

            localStorage.setItem("syncItemUsername", username);
            localStorage.setItem("syncItemPassword", "");
            
            this.dataSvc.attemptLoginLocally();
            this.loadData();
            this.onInit();
          });
          clearInterval(this._loadInterval);
        }
      }, 2000);
    } else {
      if (eproctLoaded) {
        this.dataSvc.showLoading("Reloading exam data...");
        this._loadInterval = setInterval( () => {
          if(!this.dataSvc.syncingConfig){
            this.dataSvc.attemptLoginLocally();
            this.loadData();
            this.onInit();
            clearInterval(this._loadInterval);
          }
        }, 2000);
      } else {
        this.loadData();
      }
    }
  }

  loadData() {
    if (this.dataSvc.currentUser.ScheduleCandidate == null || this.dataSvc.currentUser.Exams.length == 0)
      this.generalSvc.logoutUser();

    if (this.dataSvc.currentExamIndex == -1)
      this.generalSvc.loginUser();

    // find first un-answered question;
    var i = 0;
    var qfound = false;
    this.dataSvc.currentExam().Questions.forEach(question => {
      if (question.Disabled != true && !qfound){
        this.dataSvc.setQuestion(i);
        qfound = true;
      }
      i++;
    });

    if (!qfound)
      this.dataSvc.setQuestion(i);

    this.isLoaded = true;
  }

  ngOnInit() {
    if (!(this.dataSvc.getParameterByName("eproctored") == "1")) {
      
      this.onInit();
    }
  }

  onInit() {
    this.initiateTimer();
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    this.isLoaded = true;
    window.parent.postMessage('exam-start', '*');
  }

  initiateTimer(){
    var timerMins = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.AssessmentTime;  

    var adaptedTime = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTime += (scheduleCandidate.ExtraTime / 60);
      }
    }

    timerMins += adaptedTime;

    var seconds = timerMins * 60;
    var checkTime = seconds - this.dataSvc.currentExam().Session.Timetaken;    
    if(checkTime <= 0){
      clearInterval(this.dataSvc.interval);
      this.markCompleted();
    }
    else{
      var timeRemaining = localStorage.getItem("timeRemaining" + this.dataSvc.currentExam().Session.SessionId);      
      if(this.isNumeric(timeRemaining))
      {
        checkTime = parseInt(timeRemaining);       
      }

      this.startTimer(checkTime);
    }
    // removed comments 13/10/2023
  }

  startTimer(duration){
      this.dataSvc.currentExam().Session.timer = duration;
      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {          

          //STANDARD ENETASSESS TIMER LOGIC
          this.dataSvc.currentExam().Session.minutes = parseInt(this.dataSvc.currentExam().Session.timer) / 60;
          this.dataSvc.currentExam().Session.seconds = parseInt(this.dataSvc.currentExam().Session.timer) % 60;

          this.dataSvc.currentExam().Session.minutes = this.dataSvc.currentExam().Session.minutes < 10 ? "0" + this.dataSvc.currentExam().Session.minutes : this.dataSvc.currentExam().Session.minutes;
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.seconds < 10 ? "0" + this.dataSvc.currentExam().Session.seconds : this.dataSvc.currentExam().Session.seconds;
          var pat = /\b(900)\b/g;
          if (--this.dataSvc.currentExam().Session.timer < 0) {
            this.dataSvc.currentExam().Session.timer = 0;
            // alert("Exam Finished");
            clearInterval(this.dataSvc.interval);
            this.markCompleted();
            this.dataSvc.currentQuestion().Question.ExtraTimeUsed = (this.dataSvc.currentExam().Session.timer * -1)
          }
          else if(this.dataSvc.currentExam().Session.timer == 900 || this.dataSvc.currentExam().Session.timer.toString().match(pat)){
            document.getElementById("btnOpenTimer").click();
          }
          
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.timer;
          this.dataSvc.currentExam().Session.duration = moment.duration(this.dataSvc.currentExam().Session.seconds, 'seconds');          
          this.examTimerString = this.dataSvc.currentExam().Session.duration.format("hh:mm:ss");

          // construct exam time taken;
          this.dataSvc.currentExam().Session.Timetaken++;

          // set time spent on question;
          if (this.dataSvc.currentQuestion().Question.TimeSpent == null || this.dataSvc.currentQuestion().Question.TimeSpent == undefined)
            this.dataSvc.currentQuestion().Question.TimeSpent = 0;

          this.dataSvc.currentQuestion().Question.TimeSpent ++;
          localStorage.setItem("timeRemaining" + this.dataSvc.currentExam().Session.SessionId, this.dataSvc.currentExam().Session.timer);
        }
      }, 1000);
  }

  startExtraTimeTimer(){
        
  }

  isExamTimeFinished(endTime, startTime, allottedTime){
    var now = moment().format();
    var end = moment(endTime).format();
    if(now >= end){
      //clearInterval(this.dataSvc.interval);
      //this.dataSvc.EndExam();
    }
    else{
      var start = moment(startTime).format();
      var difference = moment.duration(moment().diff(moment(start))).as('minutes');
      var minutes = difference;
      var allowedtime = (parseInt(allottedTime) * 60);
      var correctTime = allowedtime - (minutes * 60);
      return correctTime;
    }
  }

  getStyles(){
    var css = this.dataSvc.currentExam().Session.AssessmentThemeCss;
    if(css !== null && css !== undefined && css !== ""){
      var cssStr = "<style>" + css + "</style>";
      return this.domSanitizer.bypassSecurityTrustHtml(cssStr);
    }
  }

  isNumeric(str: string) {
    return !isNaN(parseInt(str))
  }

  markCompleted() {
    this.showExamCompleteMsg = true;
  }
  
}